import { ContentPlayer } from '@/components/courses/player/ContentPlayer';
import { useCourse } from '@/hooks/query';
import { FlexContainer } from '@/ui/styled-ui';
import { ProgressSpinner } from 'primereact/progressspinner';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

export const ContentPlayerPage: React.FC = () => {
  const { t } = useTranslation();
  const { id: courseId } = useParams();

  // Fetch course data
  const { course, isLoading: isCourseLoading } = useCourse({
    courseId,
    staleTime: Infinity,
  });

  return (
    <>
      {isCourseLoading && (
        <FlexContainer direction="column" className="h-full">
          <FlexContainer direction="column" className="mt-5 flex-1">
            <ProgressSpinner />
            <h3>{t('content.loading')}</h3>
          </FlexContainer>
        </FlexContainer>
      )}

      {!isCourseLoading && course && <ContentPlayer course={course} />}
    </>
  );
};
